<div class="mt-2">
  <app-event [screen]="'CASE_DETAILS'" [memberId]="member.id" [caseId]="model.id" (saveTask)="afterTaskAdded()">
  </app-event>
</div>